class SeoContent extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this._handleClick.bind(this));
  }

  _handleClick(event) {
    const trigger = event.target.closest('[data-trigger]');
    if (!trigger) return;

    const panelId = trigger.getAttribute('aria-controls');
    const panel = document.getElementById(panelId);
    if (!panel) return;

    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

    this.querySelectorAll(`[aria-controls="${panelId}"]`).forEach(t => {
      t.setAttribute('aria-expanded', String(!isExpanded));
    });

    if (isExpanded) {
      panel.classList.remove('active');
      panel.classList.add('inactive');
      panel.setAttribute('aria-hidden', 'true');

      const stickyHeader =
        document.querySelector('sticky-header') ||
        document.querySelector('.header-sticky-wrapper');
      const headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
      const top = this.getBoundingClientRect().top + window.scrollY - headerHeight - 25;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    } else {
      panel.classList.remove('inactive');
      panel.classList.add('active');
      panel.setAttribute('aria-hidden', 'false');
    }
  }
}

if (!customElements.get('seo-content')) {
  customElements.define('seo-content', SeoContent);
}
